<template>
  <section
    v-if="data.length > 0"
    class="grid place-content-center rounded-lg bg-primary-50 px-8 pb-8 text-center text-primary-950"
  >
    <app-image
      alt=""
      class="mx-auto -mt-8 mb-4"
      src="/images/illustrations/trainer_trained_organizations.svg"
    />
    <h2 class="mb-8 text-2xl font-extrabold">
      {{
        $t("teacher.page.trained_organizations_title", {
          name: teacher.first_name,
        })
      }}
    </h2>

    <ul class="flex flex-wrap items-center justify-center gap-3">
      <li
        v-for="organization in data"
        :key="organization.name"
        class="rounded bg-white px-3 py-2"
      >
        <app-image
          :alt="organization.name"
          :height="35"
          :src="organization.logo_url"
        />
      </li>
    </ul>
  </section>
</template>

<script lang="ts" setup>
const properties = defineProps<{
  teacher: DatabaseTable<"teachers">;
}>();

const { data } = useLazyFetch(
  `/api/teachers/${properties.teacher.slug}/trained-organizations`,
  {
    default: () => [],
    server: false,
  },
);
</script>
